import { Loader, Typography } from '@design-system/index';
import './PlanningCalendar.scss';
import { usePlanningCalendarVM } from './usePlanningCalendarVM';
import { RangeCalendar } from '@components/RangeCalendar/RangeCalendar';
import moment from 'moment';
import Skeleton from 'react-loading-skeleton';

export default function PlanningCalendar({ apartmentId, hideDetails = false }: { apartmentId: string | number, hideDetails?: boolean }) {
    const { bookingRange, onShownDateChange, currentRange, isLoadingBookingRange } = usePlanningCalendarVM({ apartmentId });
    return (
        <div className="planning-page-container">
            {(isLoadingBookingRange && hideDetails) && <div className="planning-page-container-loader">
                <Loader />
            </div>}
            <RangeCalendar
                selectedDates={(bookingRange ?? []).reduce((acc, range) => {
                    return [...acc, ...range.dates.map((date) => new Date(date))];
                }, [] as Date[])}
                onShownDateChange={onShownDateChange}
            />
            {!hideDetails && <div className="planning-page-container-recap">
                {currentRange &&
                    [currentRange.start, currentRange.end].map((range) => (
                        <div className="recap-item" key={range}>
                            <>
                                <div className="recap-item-header">
                                    <Typography intrinsic="h3" color="secondary" className="recap-item-header-month">
                                        {moment(range).format('MMMM YYYY')}
                                    </Typography>
                                    {isLoadingBookingRange ? <Skeleton count={1} circle={false} baseColor="#E1F0FA" highlightColor="#F6FAFC" height={22} /> :
                                        <Typography intrinsic="h3" color="primary">
                                            {
                                                bookingRange?.filter((booking) =>
                                                    booking.dates.some((date) => moment(date).isSame(range, 'month'))
                                                ).length
                                            }{' '}
                                            réservations
                                        </Typography>
                                    }
                                </div>
                                <div className="recap-item-content">
                                    {isLoadingBookingRange ? <Skeleton count={1} circle={false} baseColor="#E1F0FA" highlightColor="#F6FAFC" height={32} width={120} /> : <>
                                    {(bookingRange ?? [])
                                        .filter((booking) =>
                                            booking.dates.some((date) => moment(date).isSame(range, 'month'))
                                        )
                                        .map((booking, index) => (
                                            <div className="recap-item-content-item" key={index}>
                                                <span>{booking.member.fullname}</span>
                                                <span>
                                                    Du {moment(booking.dates[0]).format('DD/MM')} au{' '}
                                                    {moment(booking.dates[booking.dates.length - 1]).format('DD/MM')}
                                                </span>
                                            </div>
                                    ))}
                                    {bookingRange?.filter((booking) =>
                                        booking.dates.some((date) => moment(date).isSame(range, 'month'))
                                    ).length === 0 && (
                                        <Typography intrinsic="p" color="secondary">
                                            Aucune réservation
                                        </Typography>
                                    )}
                                    </>}
                                </div>
                            </>
                          
                        </div>
                    ))}
            </div>}
        </div>
    );
}
